<template>
  <div>
    <v-app-bar v-if="$vuetify.display.xs || $vuetify.display.sm || $vuetify.display.md" fixed app clipped-right>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon><span align="center">eMOC II</span>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      :rail="mini"
      :permanent="!$vuetify.display.xs && !$vuetify.display.sm && !$vuetify.display.md"
      class="moc-nav"
    >
      <v-list dense>
        <v-list-item>
          <template v-slot:prepend>
            <v-avatar color="grey-darken-3" size="32">
              <v-img :src="userImageSrc"></v-img>
            </v-avatar>
          </template>
          <v-list-item-title v-text="user.displayName"></v-list-item-title>
        </v-list-item>
      </v-list>
      <navigation :roles="roles"></navigation>
      <template v-slot:append>
        <template v-if="roles.find((x) => x === 'ProcessManager' || x === 'ITSupport')">
          <v-dialog close-on-content-click max-width="500" v-model="showArchives">
            <archive-list v-show="showArchives"></archive-list>
          </v-dialog>
          <v-list-item @click.stop="showArchives = true">
            <template v-slot:prepend>
              <v-tooltip :text="$t('Archives')">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props">mdi-archive-arrow-down-outline</v-icon>
                </template>
              </v-tooltip>
            </template>
            <v-list-item-title v-text="$t('Archives')"></v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item>
          <v-tooltip :text="mini ? 'Show More Information' : 'Show Less Information'">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" @click.stop="mini = !mini">{{ mini ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
            </template>
          </v-tooltip>
        </v-list-item>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import MOCAdminService from '@/services/admin.service'
import { mapState } from 'vuex'
import ArchiveList from '@/components/archive/ArchiveList'
import MSGraphService from '@/services/msgraph.service'
import { EventBus } from '@/common/event-bus'

export default {
  name: 'NavBar',
  data: () => ({
    roles: [],
    drawer: null,
    drawerRight: false,
    right: false,
    left: false,
    isDark: null,
    pickedStyle: '',
    currentStatus: 'currentStatus',
    showArchives: false,
    infoPanelDialogs: {
      tasks: false,
      supportingDocuments: false,
      supportingLinks: false,
      viewing: false
    },
    mini: true,
    userImageSrc: '',
    communityAbbreviation: null
  }),
  props: {
    source: String
  },
  components: {
    Navigation,
    ArchiveList
  },
  computed: {
    ...mapState('personalSettings', ['dark']),
    ...mapState('currentUser', ['user']),
    ...mapState('currentMoc', ['id', 'status'])
  },
  methods: {
    async getUserImageUrl(user) {
      // set temp image in case user has none
      MSGraphService.getInitialsImageUrl(user).then((r) => {
        this.userImageSrc = r
      })
      MSGraphService.getUserImageUrl(user)
        .then((r) => {
          this.userImageSrc = r
        })
        .catch((e) => {
          e
        })
    },
    setRoles() {
      if (this.$store.state.currentCommunity.community.communityAbbreviation != null) {
        MOCAdminService.getWithCommunityRoles(this.$store.state.currentCommunity.community.communityAbbreviation)
          .then((response) => {
            this.roles = response
            this.$store.dispatch('currentUserAdminRoles/getMyAdminRoles', response)
          })
          .catch(() => {
            // TODO; write metrics here as required for this error
          })
          .finally(() => {})
      } else {
        MOCAdminService.getRoles()
          .then((response) => {
            this.roles = response
            this.$store.dispatch('currentUserAdminRoles/getMyAdminRoles', response)
          })
          .catch(() => {
            // TODO; write metrics here as required for this error
          })
          .finally(() => {})
      }
    }
  },
  created() {
    EventBus.on('updateNavRoles', () => {
      this.setRoles()
    })
  },
  beforeMount: function () {
    this.getUserImageUrl(this.user)
  },
  mounted() {
    // set the community abbrev here in case someone came from a direct link
    this.$store.dispatch('currentCommunity/setCommunity', {
      communityAbbreviation: this.$route.params.shortName
    })

    this.setRoles()
    this.$store.dispatch('currentUser/getMe')
    this.isDark = this.$store.state.personalSettings.dark
    this.$vuetify.theme.dark = this.isDark
  },
  watch: {
    isDark: {
      handler() {
        this.$store.dispatch('personalSettings/setIsDark', this.isDark)
        this.isDark = this.$store.state.personalSettings.dark

        //TODO (tony) this is a workaround for a bug in vuetify when switching themes
        // the colors do not get applied to the light theme if the theme.dark is not
        // changed.  This causes an error in the console.  They should be fixing this.
        // I can submit to them if I get the time
        if (!this.isDark) {
          this.$vuetify.theme.dark = true
        }
        this.$vuetify.theme.dark = this.isDark
      }
    }
  }
}
</script>

<style>
.screenHeading {
  font-size: 18px;
  font-weight: 400;
}
.blue-link {
  color: #0000ee;
  text-decoration: underline;
  cursor:pointer;
}



div.v-input,
.v-input {
  font-size: 0.95rem;
}

.v-toolbar__title {
  font-size: 0.95rem;
}

.v-list-item__title {
  font-size: 0.95rem;
}

html {
  font-size: 0.95rem !important;
}
</style>
